export default __webpack_public_path__ + "static/media/amogh.95640ddd.jpg";